import React from 'react'
import { Box } from '@mui/material'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import NotificationCard from './NotificationCard'

function NotificationStack({ notifications, onRemove }) {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 10,
        right: 10,
        zIndex: 1000,
        width: '100%',
        maxWidth: { xs: '100%', md: '400px' },
        display: 'flex',
        flexDirection: 'column-reverse',
        alignItems: 'flex-end',
      }}
    >
      <TransitionGroup>
        {notifications.map((notification) => (
          <CSSTransition key={notification.id} timeout={300} classNames="notification">
            <NotificationCard
              key={notification.id}
              title={notification.title}
              text={notification.text}
              type={notification.type}
              primaryActionLabel={notification.primaryActionLabel}
              primaryActionOnClick={notification.primaryActionOnClick}
              secondaryActionLabel={notification.secondaryActionLabel}
              secondaryActionOnClick={notification.secondaryActionOnClick}
              onClose={() => onRemove(notification.id)}
            />
          </CSSTransition>
        ))}
      </TransitionGroup>
    </Box>
  )
}

export default NotificationStack
